export function GetQuarter(date: Date) {
  const jan = new Date(date.getFullYear(), 0, 1);
  const apr = new Date(date.getFullYear(), 3, 1);
  const jul = new Date(date.getFullYear(), 6, 1);
  const oct = new Date(date.getFullYear(), 9, 1);
  //jan, apr, jul, oct
  if (date >= jan && date < apr) return 1;
  if (date >= apr && date < jul) return 2;
  if (date >= jul && date < oct) return 3;
  if (date >= oct) return 4;

  throw new Error('Invalid Date');
}

export function GetPreviousQuarter(date: Date) {
  const jan = new Date(date.getFullYear(), 0, 1);
  const apr = new Date(date.getFullYear(), 3, 1);
  const jul = new Date(date.getFullYear(), 6, 1);
  const oct = new Date(date.getFullYear(), 9, 1);
  //jan, apr, jul, oct
  if (date >= jan && date < apr) return 4;
  if (date >= apr && date < jul) return 1;
  if (date >= jul && date < oct) return 2;
  if (date >= oct) return 3;

  throw new Error('Invalid Date');
}

export function GetQuarterStart(quarter: number, year: number) {
  const jan = new Date(year, 0, 1);
  const apr = new Date(year, 3, 1);
  const jul = new Date(year, 6, 1);
  const oct = new Date(year, 9, 1);

  switch (quarter) {
    case 1:
      return jan;
    case 2:
      return apr;
    case 3:
      return jul;
    case 4:
      return oct;
  }

  throw new Error('Invalid Date');
}

export function GetQuarterEnd(quarter: number, year: number) {
  const dec = new Date(year + 1, 0, 0);
  const march = new Date(year, 3, 0);
  const june = new Date(year, 6, 0);
  const sept = new Date(year, 9, 0);
  //jan, apr, jul, oct
  switch (quarter) {
    case 1:
      return march;
    case 2:
      return june;
    case 3:
      return sept;
    case 4:
      return dec;
  }

  throw new Error('Invalid Date');
}

export function GetQuarterStartFromDate(date: Date) {
  const quarterNumber = GetQuarter(date);
  return GetQuarterStart(quarterNumber, date.getFullYear());
}

export function GetQuarterEndFromDate(date: Date) {
  const quarterNumber = GetQuarter(date);
  return GetQuarterEnd(quarterNumber, date.getFullYear());
}
